export const LOCAL_STORAGE_SUBSTITUTED_USER_FLAG =
  "SINCHAPP_LOCAL_STORAGE_SUBSTITUTED_USER_FLAG";
export const SMOKE_TEST_USER_METADATA_KEY = "SMOKE_TEST_USER";
export const USER_PERSONA = "USER_PERSONA";
export const USER_GOAL = "USER_GOAL";
export const USER_MARKETING_PLATFORM = "USER_MARKETING_PLATFORM";
export const USER_PROGRAMMING_LANGUAGE = "USER_PROGRAMMING_LANGUAGE";
export const USER_CODE_EXPERIENCE = "USER_CODE_EXPERIENCE";
export const USER_FIRST_PRODUCT = "USER_FIRST_PRODUCT";
export const LOCAL_STORAGE_TOKEN_KEY = "SINCHAPP_LOCAL_STORAGE_TOKEN_KEY";
export const LOCAL_STORAGE_PRODUCT_KEY = "SINCHAPP_LOCAL_STORAGE_PRODUCT_KEY";
export const LOCAL_STORAGE_SKYCORE_WIDGET_TOKEN =
  "LOCAL_STORAGE_SKYCORE_WIDGET_TOKEN";
export const LOCAL_STORAGE_SKYCORE_SERVICE_TOKEN =
  "LOCAL_STORAGE_SKYCORE_SERVICE_TOKEN";
export const LOCAL_STORAGE_NOVU_SUBSCRIBER_ID = "novuSubscriberId";
export const LOCAL_STORAGE_NOVU_SUBSCRIBER_ID_HASH = "novuSubscriberHash";
